import { notification } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UseMutateFunction, useMutation, useQueryClient } from 'react-query'

import { QUERY_KEYS } from '@api'
import { AxiosErrorType, BlockTrainFilePayload } from '@types'

import BlocktrainApi from './api'

interface UseBlockTrainFilesReturn {
  uploadBlocktrainFile: UseMutateFunction<any, unknown, BlockTrainFilePayload, void>
  uploadBlocktrainFileIsFetching?: boolean
}

const useBlockTrainFiles = (): UseBlockTrainFilesReturn => {
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const [uploadBlocktrainFileIsFetching, setUploadBlocktrainFileIsFetching] = useState<boolean>()

  const onError = (error: unknown) => {
    setUploadBlocktrainFileIsFetching(false)
    const errorData = error as AxiosErrorType

    if (errorData.data.error.message.toLowerCase() === 'extension not allowed') {
      notification.error({
        message: t('format_error'),
      })
    } else if (errorData.data.error.type.toLowerCase() === 'invalid_file_size') {
      notification.error({
        message: t('file_size_error'),
      })
    } else {
      notification.error({
        message: t('generic_error'),
      })
    }
  }

  const onSuccess = () => {
    notification.success({
      message: t('successful_upload'),
    })
    queryClient.invalidateQueries([QUERY_KEYS.BLOCKTRAIN])
    setUploadBlocktrainFileIsFetching(false)
  }

  const { mutate: uploadBlocktrainFile } = useMutation(BlocktrainApi.uploadBlockTrainFile, {
    onError,
    onSuccess,
    onMutate: () => {
      setUploadBlocktrainFileIsFetching(true)
    },
  })

  return {
    uploadBlocktrainFile,
    uploadBlocktrainFileIsFetching,
  }
}

export default useBlockTrainFiles
